import React from 'react'
import type { Icon } from 'shared/utils'

const Shop = (props: Icon) => {
    const {
        color = 'black',
        size = 23,
        className = 'shop',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 23 25"
            {...otherProps}>
            <g transform="translate(-1 1)" fill="none" fillRule="evenodd">
                <g fill={color} fillRule="nonzero">
                    <path d="M23.765 6.806V4.835c0-.047 0-.094-.047-.141v-.047c0-.047-.047-.047-.047-.094L20.573.423a.427.427 0 00-.375-.188H4.802a.427.427 0 00-.375.187L1.329 4.553c0 .047-.047.047-.047.094v.047c0 .047-.047.094-.047.14v1.972c0 .798.375 1.55.985 2.018-.047.047-.047.141-.047.188v12.815h-.469c-.282 0-.47.187-.47.469s.188.47.47.47h21.592c.282 0 .47-.188.47-.47s-.188-.47-.47-.47h-.47V8.967c0-.048 0-.095-.046-.142.61-.469.985-1.22.985-2.018zm-1.408-2.44h-3.05l-1.409-3.099-.047-.047h2.112l2.394 3.145zM9.871 6.805c0 .939-.75 1.69-1.69 1.69-.938 0-1.69-.751-1.69-1.69V5.304h3.38v1.502zm-1.69-5.633h2.254l-.47 3.192H6.773l.047-.047 1.362-3.145zm8.637 0l1.409 3.098.046.047h-3.191l-.47-3.191h2.206v.046zm-2.722 3.192h-3.239l.47-3.192h2.253l.516 3.192zm-3.286.94h3.38v1.501c0 .939-.751 1.69-1.69 1.69s-1.69-.751-1.69-1.69V5.304zm4.319 0h3.38v1.501c0 .939-.752 1.69-1.69 1.69-.94 0-1.69-.751-1.69-1.69V5.304zM5.037 1.172h2.112l-.047.047-1.408 3.098H2.643l2.394-3.145zM2.173 5.304h3.38v1.502c0 .939-.751 1.69-1.69 1.69s-1.69-.751-1.69-1.69V5.304zm3.474 16.523v-9.764h4.835v9.764H5.647zm16.24 0H11.42V11.594c0-.282-.187-.47-.469-.47H5.178c-.282 0-.47.188-.47.47v10.233H3.112V9.294c.235.094.47.14.751.14.892 0 1.69-.469 2.16-1.126.469.704 1.267 1.127 2.159 1.127.891 0 1.69-.47 2.159-1.127.47.704 1.267 1.127 2.159 1.127.892 0 1.69-.47 2.16-1.127.469.704 1.267 1.127 2.158 1.127.892 0 1.69-.47 2.16-1.127.469.704 1.267 1.127 2.159 1.127.281 0 .516-.047.75-.094v12.486zm.94-15.02c0 .938-.751 1.689-1.69 1.689s-1.69-.751-1.69-1.69V5.304h3.38v1.502z" />
                    <path d="M20.667 12.627h-7.322c-.282 0-.47.187-.47.469v4.46c0 .28.188.468.47.468h7.322c.282 0 .47-.187.47-.469v-4.46c0-.28-.188-.468-.47-.468zm-.469 4.459h-6.384v-3.52h6.384v3.52z" />
                </g>
            </g>
        </svg>
    )
}

export { Shop }
